export default __webpack_public_path__ + "static/media/settings.0a624c2e.svg";